import React from "react";
import {useWarehouseModel} from "../warehouseModel";
import {AppDrawer} from "../../../../components/YhDrawer";
import {FormItemTypeEnum, IYhForm} from "../../../../components/YhFormBox/Types";
import {YhForm} from "../../../../components/YhFormBox";


export function DetailDrawer() {
    const {drawerVisible: visible, setDrawerVisible, selectedData} = useWarehouseModel();
    const onCancel = () => {
        setDrawerVisible(false);
    }

    const formConfig: IYhForm = {
        labelCol: {span: 6},
        disabled: true,
        formValues: selectedData,
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "分支",
                fieldName: "branch",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "版本",
                fieldName: "ver",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "启用",
                fieldName: "enable",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "编码",
                fieldName: "code",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "名称",
                fieldName: "name",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "从属机构",
                fieldName: "orgName",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系人",
                fieldName: "contact",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phone",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "地址",
                fieldName: "address",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "状态",
                fieldName: "status",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 24,
            }
        ]
    };
    return (
        <AppDrawer
            {...{
                title: "仓库信息",
                visible,
                onCancel,
                showFooter: false
            }}
        >
            <YhForm {...formConfig}/>
        </AppDrawer>
    )
}
